import { RocketAPI } from '@portal/rocket-api-client';
import { createFileRoute } from '@tanstack/react-router';

import ChangePassword from 'component/view/Settings/ChangePassword';

import { requireOperation } from './-guards';

export const Route = createFileRoute(
  '/n/_auth/settings/_layout/account-and-security/change-password'
)({
  beforeLoad: requireOperation({
    options: () => RocketAPI.account.getChangeAccountPasswordMutationOptions(),
    redirectTo: '/n/settings/account-and-security',
  }),
  component: ChangePassword,
});
